import React from 'react';
import { useTenant } from '../../../context/TenantContext';
import { warmInlineEm } from './warmInlineEm';

const DEFAULTS = {
  eyebrow: 'What we believe',
  statement:
    'Learning is something *we do together* — not something done to us, alone, in front of a screen.',
};

export const WarmBelief: React.FC = () => {
  const { tenant } = useTenant();
  const belief = tenant?.branding.marketing?.belief;
  const eyebrow = belief?.eyebrow?.trim() || DEFAULTS.eyebrow;
  const statement = belief?.statement?.trim() || DEFAULTS.statement;

  // Only render when tenant explicitly set a belief, OR keep the
  // default for the unconfigured warm tenant. Currently: always show
  // (the warm theme implicitly invites a manifesto).
  if (belief && belief.statement === '') return null;

  return (
    <section id="belief" className="warm-belief py-16 md:py-20 text-center bg-[var(--warm-paper-deep)] border-t border-b border-[var(--warm-rule)]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="font-warm-hand text-2xl text-[var(--warm-accent-deep)] mb-3">
          {eyebrow}
        </div>
        <p className="font-warm-serif text-3xl md:text-5xl leading-[1.15] tracking-tight text-[var(--warm-ink)] max-w-[22ch] mx-auto text-balance">
          {warmInlineEm(statement)}
        </p>
      </div>
    </section>
  );
};
